import React from 'react';
import {
    Table,
    Tr,
    Td,
    Th,
    css,
    Grid,
    Header,
    Div,
} from "@bdfx/fukit"
import {formatInt} from "../../common/format"
import { Bar } from 'react-chartjs-2'
import ctrans from "../../common/trans"
import Chart from "chart.js"
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.pluginService.register(ChartDataLabels);



function Competitors({competitors}) {
    const getBarData = () => ({
        labels: competitors.map(c => c.name),
        datasets: [
            {
                label:  ctrans("competitor_is")+ " " +ctrans("lower_in_bidding").toLowerCase(),
                data: competitors.map(c => c.worse_position),
                backgroundColor: "#ff9d17",
            },
            {
                label: ctrans("competitor_is")+ " " + ctrans("higher_in_bidding").toLowerCase(),
                data: competitors.map(c => c.better_position),
                backgroundColor: "#89d323",
            }, 
            {
                label: ctrans("im_not_in_bidding"),
                data: competitors.map(c => c.im_not_in_bidding),
                backgroundColor: "#959393",
            }, 
        ]
    })
    const getBarOptions = () => ({
        plugins: {
            datalabels: {
              display: false,
            }
          },
        legend: {
            reverse: true,
            align: "start",
            fullWidth: false,
            labels: {
                boxWidth: 15,
            },
        },        
        scales: {
            yAxes: [{
                stacked: true,
                ticks: {
                    callback: formatInt,
                },
                scaleLabel: {
                    display: true,
                    labelString: ctrans("products_count"),
                },
                gridLines: {
                    color: "#e1e1e1",
                    zeroLineColor: "#e1e1e1",
                }
            }],
            xAxes: [{
                stacked: true,
                gridLines: {
                    display: true,
                    color: "#e1e1e1",
                    zeroLineColor: "#e1e1e1",
                },
                ticks: {
                    callback: function(value) {
                        if(value.length > 7) {
                            return value.substr(0, 7)+"..";//truncate
                        }
                        return value
                    },    
                },
            }]

        },
    })
    
    return (
        <Style className="section competitors npbreak">
            <Header type={2}>
                {ctrans("most_common_competitors")} {ctrans("in_bidding").toLowerCase()}
            </Header>
            <Grid cols="650px 500px" gap="50px">
                <Div marginTop="-30px" width="100%" className="competitors-graph">
                    <Bar height={180} options={getBarOptions()} data={getBarData()} />
                </Div>
                <Div>
                    <Table header={[
                            <Th key={"eshop"} align="left">E-shop</Th>,
                            ctrans("lower_in_bidding"),
                            ctrans("higher_in_bidding"),
                            ctrans("im_not_in_bidding"),
                    ]}>
                        {competitors.map(competitor => (
                            <Tr key={competitor.name}>
                                <Td align="left">{competitor.name}</Td>
                                <Td>{Math.round(competitor.worse_position * 100 / competitor.count_sum)} %</Td>
                                <Td>{Math.round((competitor.better_position)  * 100 / competitor.count_sum)} %</Td>
                                <Td>{Math.round((competitor.im_not_in_bidding)  * 100 / competitor.count_sum)} %</Td>
                            </Tr>

                        ))}                    
                </Table>
                </Div>
            </Grid>
        </Style>
  );
}

const Style = css("div")({
    background: "#ffeced",
    paddingBottom: "100px",
    "> div": {
        maxWidth: "1200px",
        margin: "auto",
        position: "relative",
        zIndex: 1,
    },
    "th": {
        whiteSpace: "nowrap",
    },
    ".fuk-header.h2": {
        marginTop: "0",
        marginBottom: "1.5em",
    },
    "@media only screen and (max-width: 1000px)": {
        ".fuk-grid": {
            display: "block",
        }
    },
})

export default Competitors;
